import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class StorageService {

    private readonly PREFERRED_ERZEUGUNGSANLAGEN_VIEW = 'preferred-ea_view';
    private readonly PREFERRED_LEISTUNGSEINHEIT_VIEW = 'preferred-power_view';
    private readonly PRESELECTED_TEILGEBIET_STWID = 'preselected-teilgebiet-stwid';

    public getPreferredErzeugungsanlagenView(): string | null {
        return localStorage.getItem(this.PREFERRED_ERZEUGUNGSANLAGEN_VIEW);
    }

    public setPreferredErzeugungsanlagenView(view: string) {
        localStorage.setItem(this.PREFERRED_ERZEUGUNGSANLAGEN_VIEW, view);
    }

    public getPreferredLeistungseinheitView(): string | null {
        return localStorage.getItem(this.PREFERRED_LEISTUNGSEINHEIT_VIEW);
    }

    public setPreferredLeistungseinheitView(view: string) {
        localStorage.setItem(this.PREFERRED_LEISTUNGSEINHEIT_VIEW, view);
    }

    public getPreselectedTeilgebietStwId(): string | null {
        return sessionStorage.getItem(this.PRESELECTED_TEILGEBIET_STWID);
    }

    public setPreselectedTeilgebietStwId(view: string) {
        sessionStorage.setItem(this.PRESELECTED_TEILGEBIET_STWID, view);
    }

    public deletePreselectedTeilgebietStwId() {
        sessionStorage.removeItem(this.PRESELECTED_TEILGEBIET_STWID);
    }

}
